import { api } from '@/lib/api'

export interface Organisation {
  id: number
  naam: string
  kvk?: string | null
  contactpersoon?: string | null
  bederfelijke_waar: string
  fin_pct_voorraad: number
  fin_pct_emballage: number
  fin_pct_verpakking: number
  fin_pct_overig: number
  min_houdbaarheidsdagen: number
  actief: boolean
  aanmaakdatum?: string | null
}

export async function fetchOrganisations(): Promise<Organisation[]> {
  const { data } = await api.get<Organisation[]>('/api/organisations')
  return data
}

export async function fetchOrganisation(id: number): Promise<Organisation> {
  const { data } = await api.get<Organisation>(`/api/organisations/${id}`)
  return data
}
